import { render, staticRenderFns } from "./DashboardLanguage.vue?vue&type=template&id=27e04374&scoped=true&"
import script from "./DashboardLanguage.vue?vue&type=script&lang=js&"
export * from "./DashboardLanguage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLanguage.vue?vue&type=style&index=0&id=27e04374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e04374",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VFileInput,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e04374')) {
      api.createRecord('27e04374', component.options)
    } else {
      api.reload('27e04374', component.options)
    }
    module.hot.accept("./DashboardLanguage.vue?vue&type=template&id=27e04374&scoped=true&", function () {
      api.rerender('27e04374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/DashboardLanguage.vue"
export default component.exports